(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.gifReplay = {
    attach: (context) => {

      if (!$('.animated-gif__wrapper', context).length) {
        return;
      }

      // Create and activate replay button for each embed.
      $(once('gifReplayButton', '.animated-gif__wrapper', context)).each(function () {
        var src = $(this).find('img').attr('src');
        var alt = $(this).find('img').attr('alt');
        var $replayButton = $('<a href="#" class="animated-gif__button" data-src="' + src + '" aria-label="Replay ' + alt + '"><i class="icon-replay">&nbsp;</i>replay</a>');
        $replayButton.click(function (e) {
          e.preventDefault();
          $(this).parent().find('img').attr('src', $(this).data('src'));
        });
        $(this).append($replayButton);
      });

    }
  };

})(jQuery, Drupal);
